import { ReactNode } from "react"
import { useToggle } from "react-use"
import { useParams } from "react-router-dom"

import { Img } from "ui-kit/components-branded/index"
import { PaymentWidget } from "components"
import { usePaymentContext } from "modules/Payment/PaymentContext"
import { CurrencySelectorPayment } from "modules/BookingCommon/components"
import { updateCurrency } from "modules/BookingCommon/common/api"

export function ErrorPage({
    headline,
    secondary,
}: {
    headline: string
    secondary: ReactNode
    tryAgain?: boolean
    buttonText?: string
}) {
    const { id } = useParams<{ id: string }>()
    const [{ currency, bookingDetails }, { setCurrency, setBookingDetails }] = usePaymentContext()
    const [rerenderWidget, toggleRenderWidget] = useToggle(false)

    function handleClickGoAgain() {
        void updateCurrency(bookingDetails.order_hash, currency)
            .then(({ payment_system }) => {
                setBookingDetails({
                    ...bookingDetails,
                    payment_system,
                })
                toggleRenderWidget(true)
            })
            .catch(undefined)
    }

    if (rerenderWidget && id) {
        return (
            <div className="redesign-container">
                <PaymentWidget
                    booking_hash={id}
                    {...bookingDetails}
                    onError={() => undefined}
                    psy={PaymentWidget.getPsyData(bookingDetails.psy)}
                />
            </div>
        )
    }

    return (
        <div className="redesign-container">
            <div className="try-again__container">
                <section className="try-again">
                    <div>
                        <div className="try-again__headline">{headline}</div>
                        <div className="try-again__text">{secondary}</div>
                    </div>
                    <Img
                        className="try-again__card-illustration"
                        src="error-illustration.svg"
                        width={296}
                        height={168}
                    />
                    <CurrencySelectorPayment currency={currency} updateCurrency={setCurrency} />

                    <a
                        onClick={handleClickGoAgain}
                        className="try-again__primary-button b-button transition-ease"
                    >
                        Перейти к&nbsp;оплате еще раз
                    </a>
                </section>
            </div>
        </div>
    )
}
